<div id="integrationComissao" class="modal fade" aria-hidden="true">
    <div class="modal-dialog modal-dialog-scrollable">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title">
                    Sincronizar comissões com o ERP
                </h4>        
            </div>
            <div class="modal-body">
                <form #form="ngForm" novalidate>
                    <div class="row">
                        <div class="form-group col-12">
                            <label for="integrationComissaoPeriodicidade" class="col-form-label">Periodicidade</label>
                            <select class="form-control" name="integrationComissaoPeriodicidade" id="integrationComissaoPeriodicidade" 
                                [ngModel]="entity.periodicidade || ''" (ngModelChange)="entity.periodicidade = $event ? $event : null"
                                #integrationComissaoPeriodicidade="ngModel" required="required">
                                <option *ngFor="let periodicidade of periodicidades" [ngValue]="periodicidade.id">{{getDescricaoPeriodicidade(periodicidade.id)}}</option>
                            </select>  
                            <p class="form-text text-muted">Periodicidade da sincronização das comissões</p>
                            <sgt-form-control-error
                                *ngIf="integrationComissaoPeriodicidade.errors && integrationComissaoPeriodicidade.errors.required && integrationComissaoPeriodicidade.dirty"
                                msgError="A periodicidade é obrigatória">
                            </sgt-form-control-error>                                       
                        </div>                        
                    </div> 

                    <!-- Geral -->
                    <div class="row" *ngIf="isPeriodicidadeGeral()">
                        <div class="col-12">
                            <div class="row">
                                <div class="form-group col-12">
                                    <label class="col-form-label" for="integrationComissaoDataInicialBase">Data de Lançamento Inicial</label>
                                    <sgt-datepicker [(ngModel)]="entity.dataInicialBase" name="integrationComissaoDataInicialBase" id="integrationComissaoDataInicialBase"
                                        #integrationComissaoDataInicialBase="ngModel" [ngControl]="integrationComissaoDataInicialBase" required="required">
                                    </sgt-datepicker>
                                    <p class="form-text text-muted">Irá sincronizar as comissões lançadas a partir desta data</p>
                                    <sgt-form-control-error
                                        *ngIf="integrationComissaoDataInicialBase.errors && integrationComissaoDataInicialBase.errors.required && integrationComissaoDataInicialBase.dirty"
                                        msgError="A data inicial é obrigatória">
                                    </sgt-form-control-error>  
                                </div>                         
                            </div>
                            <div class="row">
                                <div class="col-12">
                                    <div class="alert alert-warning" role="alert">
                                        <i class="fas fa-exclamation-triangle" aria-hidden="true"></i> Atenção! Se você informar uma data de lançamento inicial muito antiga a sincronização pode levar vários minutos.
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-primary" (click)="execute()" [disabled]="form.invalid">
                    Sincronizar
                </button>              
                <button type="button" class="btn btn-light" (click)="close()">
                    Cancelar
                </button>
            </div>            
        </div>
    </div>
</div>